import NAME from "./constants";

export const getTotems = store => store[NAME].availableTotems || [];
export const gettingAvailableTotems = store => store[NAME].gettingAvailableTotems;
export const loading = store => store[NAME].loading;
export const getWorkplaces = store => store[NAME].workplaces;
